/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import config from '@linc-technologies/linced-common/utils/config';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class UserUnenrol extends Component {
  @action
  setCurrentStep(value) {
    this.currentStep = value;
  }

  @action
  setRecoveryCode(value) {
    this.recoveryCode = value;
  }

  @action
  setUseRecoveryCodes(value) {
    this.useRecoveryCodes = value;
  }

  @tracked
  currentStep;

  Scopes = Scopes;

  // Services
  @service
  fetch;

  @service
  session;

  @service
  permissions;

  // Attributes
  // isDialogOpen indicates whether the un-enrolment dialog is open
  @tracked
  isDialogOpen = false;

  // mfaId is the id of the MFA method we're un-enrolling from
  methodId = null;

  // methodName is the label from an enum
  @tracked methodName = '';

  // user is the user we're un-enrolling for
  @tracked user = null;

  // useRecoveryCodes switches between using TOTP and recovery codes for un-enrolment
  @tracked
  useRecoveryCodes = false;

  // recoveryCode is the recovery code the user's input
  @tracked
  recoveryCode = '';

  // message is the error message displayed under recovery code input
  @tracked
  message = '';

  // Computed
  // label is the dynamic label based on the method being removed
  @computed('mfaMethodName')
  get label() {
    let prefix = this.methodName === 'Text' ? 'a' : 'an';
    return `Remove ${prefix} ${this.methodName.toLowerCase()} method`;
  }

  // isTheUser indicates whether the user is performing the un-enrolment for themselves
  @computed('session.user', 'user')
  get isTheUser() {
    return this.session.get('user') === this.user;
  }

  // isLearner is used for skipping the recovery codes step, as we don't give them
  // to learners
  @computed('session.scopes.[]')
  get isLearner() {
    return this.permissions.equal(Scopes.LEARNER);
  }

  // isAuthenticator indicates whether the method being un-enrolled is an authenticator
  get isAuthenticator() {
    return this.methodName === 'Authenticator';
  }

  @action
  openDialog() {
    this.isDialogOpen = true;
  }

  @action
  closeDialog() {
    this.user.reload().then(() => {
      this.isDialogOpen = false;
    });
  }

  @action
  removeMFA(currentStep) {
    // FusionAuth automatically does the conversion for us and
    // requests personId
    let userId = this.user.get('id');
    let code = this.recoveryCode;

    // Send a request to remove an MFA method
    let uri = `${config.APP.apiHost}/auth/v4/users/${userId}/mfa/${this.methodId}`;
    let data = {
      userId: userId,
      methodId: this.methodId,
    };
    // If an admin is performing this action, they do not need a code
    if (!isEmpty(code)) {
      data.code = code;
    }
    let params = {
      data: JSON.stringify(data),
    };
    this.fetch
      .delete(uri, params)
      .then(() => {
        // Move on to the next step in the paper-stepper component
        currentStep.nextStep();
      })
      .catch(() => {
        this.recoveryCode = '';
        this.message = 'Invalid code. Please try again';
      });
  }

  @action
  nextStep(currentStep) {
    currentStep.nextStep();
  }
}
